import React from "react";
import PropTypes from "prop-types";
import TextInput from "components/v3/text-input/TextInput";
import CDSTooltipImage from "../../../images/account-tooltip-cds.png";
import styles from "./styles.module.scss";
import ErrorHandler from "components/v3/error-handler/ErrorHandler";

const BusinessweekAccountId = ({ accountId, disabled, onChange, errors }) => {
    return (
        <div className={ styles.accountId }>
            <ErrorHandler type="accountId" errors={ errors }>
                <TextInput
                    label="Businessweek Account Number"
                    name="accountId"
                    placeholder="Enter your account number"
                    value={ accountId }
                    type="text"
                    maxLength="10"
                    onChange={ (event) => onChange(event.target.value) }
                    disabled={ disabled }
                    autoFocus={ false }
                />
            </ErrorHandler>
            <TooltipImage />
        </div>
    );
};

const TooltipImage = () => {
    return (
        <div className={ styles.help }>
            <div className={ styles.tooltip }>
                <img width="225px" alt="How to find your account id" src={ CDSTooltipImage } />
            </div>
        </div>
    );
};

BusinessweekAccountId.propTypes = {
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    validate: PropTypes.bool,
    accountId: PropTypes.string,
    errors: PropTypes.object
};

export default BusinessweekAccountId;
